export default __webpack_public_path__ + "static/media/DIY-hover.4949a752.svg";